import defaultPosition from "@/helpers/wc/positionSettings";

export const deceasedListGravarSettings = {
  title: 'Deceased List Gravar',
  name: 'deceasedListGravarBase',

  styles: defaultPosition,

  properties: {
    cemeteryId: '', // obsolete, keep for backwards compability
    cemeteryIds: ["0000-0000-0000-0000-00000"],
    routeName: "",
    css: {
      caption: {
        fontFamily: "Arial",
        fontSize: '14px',
        height: '20px',
        color: 'black'
      },
      header: {
        fontFamily: "Arial",
        fontSize: 18,
        height: '30px',
        color: 'black',
        backgroundColor: 'white'
      },
      row: {
        fontFamily: "Arial",
        fontSize: 14,
        height: '30px',
        color: 'black',
        backgroundColor: 'white'
      },
      button: {
        fontFamily: "Arial",
        fontSize: 14,
        height: '30px',
        color: 'white',
        backgroundColor: 'limegreen',
        borderColor: 'grey',
        borderRadius: '5px'
      }
    }
  },
  cssLegend: {
    caption: {
      name: 'caption',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
    },
    header: {
      name: 'header',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'borderBottom'
      }
    },
    row: {
      name: 'item',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      }
    },
    button: {
      name: 'wcButton',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      borderColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    }
  }
};
